import { LoadState } from "../../constants/enums";
import {
  IInternalStoreTransfer,
  IInternalStoreTransferState,
} from "./internal-store-transfer.types";

export const defaultInternalStoreTransfer: IInternalStoreTransfer = {
  billing_company_uuid: "",
  billing_company_name: "",
  to_billing_company_uuid: "",
  to_billing_company_name: "",
  product_uuid: "",
  product_name: "",
  project_name: "",
  project_uuid: "",
  quantity: 0,
  remark: "",
};

export const defaultInternalStoreTransferState: IInternalStoreTransferState = {
  internal_store_transfer_list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
